import { AxiosResponse } from "axios";
import { OrganizationKeyName } from "../../../model/Organization";
import {
  DeletePayload,
  PostPayload,
  PutPayload,
} from "../../../model/http-crud-models";
import { MutatePackingItemPayload, PackingItem } from "../models/packing-item";
import { UpdateSortingMutationPayload } from "../../../model/UpdateSortingData";
import { httpClient, updateSorting } from "../../../service/http";

export const packingItemsHttp = {
  createPackingItem: async ({
    organizationKeyName,
    data,
  }: PostPayload<MutatePackingItemPayload>): Promise<string> => {
    const res = await httpClient<{ id: string }>({
      method: "POST",
      url: `/organizations/${organizationKeyName}/shop-product-packaging-instructions`,
      data,
    });
    return res.id;
  },

  updatePackingItem: ({
    organizationKeyName,
    data: { id, ...rest },
  }: PutPayload<MutatePackingItemPayload>): Promise<AxiosResponse> => {
    return httpClient({
      method: "PUT",
      url: `/organizations/${organizationKeyName}/shop-product-packaging-instructions/${id}`,
      data: rest,
    });
  },

  deletePackingItem: ({
    organizationKeyName,
    data: { id },
  }: DeletePayload): Promise<AxiosResponse> => {
    return httpClient({
      method: "DELETE",
      url: `/organizations/${organizationKeyName}/shop-product-packaging-instructions/${id}`,
    });
  },

  getPackingItems: async (organizationKeyName: OrganizationKeyName) => {
    const res = await httpClient<{ data: PackingItem[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/shop-product-packaging-instructions`,
    });
    return res.data;
  },

  getPackingItem: async (
    organizationKeyName: OrganizationKeyName,
    id?: string
  ) => {
    const res = await httpClient<{ data: PackingItem[] }>({
      method: "GET",
      url: `/organizations/${organizationKeyName}/shop-product-packaging-instructions`,
    });
    return res.data.find((packingItem) => packingItem.id === id);
  },

  updatePackingItemSorting: ({
    organizationKeyName,
    data,
  }: UpdateSortingMutationPayload) => {
    return updateSorting({
      organizationKeyName,
      apiRoute: "shop-product-packaging-instructions",
      data,
    });
  },
};
